export default __webpack_public_path__ + "static/media/20.96ad938f.jpg";